import React, { createElement, CSSProperties } from "react"
import cn from "classnames"

export interface BoxProps {
  className?: string;
  children?: React.ReactNode;
  element?: string;
  gap?: string;
  maxWidth?: string;
  minWidth?: string;
  padding?: string;
}

const Box: React.FC<BoxProps> = (props: BoxProps) => {
  const { children, element, gap, maxWidth, minWidth, padding } = props
  const className = cn("mz-box", props.className)

  const style: CSSProperties = {}
  if (gap) style.marginTop = gap
  if (maxWidth) style.maxWidth = maxWidth
  if (minWidth) style.minWidth = minWidth
  if (padding) style.padding = padding

  return createElement(element || "div", { className, style }, children)
}

export default Box
